<section class="btnContent">
      <div class="max-1300 text-center">
          <img class="imgRes" src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" alt="logo">
          <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
          <img src="assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
          <div class="getSt"><a href="javascript:void(0)" routerLink="/shop" class="btnSqRed">GET STARTED</a></div>
      </div>
</section>